import React from 'react';

import Fact from './Fact';

function HoC(props) {
  return (
    <Fact id="regelverk" title="Regelverk att förhålla sig till" {...props}>
      <p>
        {`
          Tänk på att det finns ett antal regelverk att förhålla sig till när
          man använder kostråden i märkning och marknadsföring. Det är
          informationsförordningen och reglerna för närings- och hälsopåstående
          samt Nyckelhålets kriterier. Du får till exempel inte använda
          icke-godkända hälsopåståenden eller utlova att livsmedel botar eller
          förebygger sjukdomar. Däremot kan du, med hjälp av kostråden, visa
          på vilka livsmedel som kan leda till bättre hälsa.
        `}
      </p>
      <ul>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.livsmedelsverket.se/produktion-handel--kontroll/livsmedelsinformation-markning-och-pastaenden/nyckelhalet---foretagsinformation"
          >
            {'Nyckelhålet'}
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.livsmedelsverket.se/produktion-handel--kontroll/livsmedelsinformation-markning-och-pastaenden/halsopastaenden/"
          >
            {'Närings- och hälsopåståenden'}
          </a>
        </li>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://www.halsopastaenden.se/handbok/"
          >
            {'Handbok för närings- och hälsopåståenden'}
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.livsmedelsverket.se/produktion-handel--kontroll/livsmedelsinformation-markning-och-pastaenden/regler-om-livsmedelsinformation-och-markning/"
          >
            {'Allmänna märkningsregler (Informationsförordningen)'}
          </a>
        </li>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.livsmedelsforetagen.se/app/uploads/2016/10/dokument.pdf"
          >
            {'Märkningshandboken'}
          </a>
        </li>
      </ul>
    </Fact>
  );
}

export default HoC;



// WEBPACK FOOTER //
// ./src/components/Fact/FactRegelverkAttForhallaSigTill.js